/* Buzz first-touch attribution — runs on EVERY page of buzz.energy.
 *
 * Why it lives in the theme and not in the form: the form sits on
 * /pages/find-my-kit, and by the time someone reaches it they have already
 * clicked through from a product page. The form's own URL carries no gclid
 * and its referrer is an internal page, so a form-only capture records
 * nothing useful. The one fact worth having — which product page the ad
 * dropped them on — only exists on the very first page view of the visit.
 *
 * Writes localStorage key `buzz_attr`:
 *   { first: {lp, gclid, src, med, cmp, ref, ts}, last: {...} }
 *
 * `first` is written once and then left alone for 90 days, so a returning
 * customer is still credited to the ad that originally found them. `last` is
 * overwritten by any later visit that arrives with a click id, a utm tag or an
 * external referrer, which answers the different question of what brought them
 * back on the day they enquired. Direct and internal navigation touch neither.
 *
 * Everything is wrapped in try/catch and fails to nothing. Storage can be
 * unavailable (private windows, browsers set to block site data) and this is
 * bookkeeping: it must never be able to break a page a customer is shopping on.
 */
(function () {
  try {
    var KEY = 'buzz_attr';
    var MAX_AGE_DAYS = 90;

    var q = new URLSearchParams(window.location.search);
    // wbraid and gbraid are what Google sends instead of gclid when the click
    // came from an app or an iOS browser with tracking limited. Treating them
    // as the same field keeps those visits from looking organic.
    var gclid = q.get('gclid') || q.get('wbraid') || q.get('gbraid') || '';

    var refHost = '';
    try {
      if (document.referrer) {
        var rh = new URL(document.referrer).hostname;
        if (rh && rh.indexOf('buzz.energy') === -1) refHost = rh;
      }
    } catch (e) { /* malformed referrer, treat as none */ }

    var touch = {
      lp: window.location.pathname,
      gclid: gclid,
      src: q.get('utm_source') || (gclid ? 'google' : '') || refHost || '',
      med: q.get('utm_medium') || (gclid ? 'cpc' : '') || (refHost ? 'referral' : ''),
      cmp: q.get('utm_campaign') || '',
      ref: refHost,
      ts: new Date().toISOString()
    };
    // A visit that carries no click id, no tag and no outside referrer tells us
    // nothing we did not already know. Recording it would overwrite the real
    // answer with "direct" the moment someone opens a second tab.
    var identified = !!(gclid || q.get('utm_source') || refHost);

    var store = {};
    try { store = JSON.parse(localStorage.getItem(KEY) || '{}') || {}; } catch (e) { store = {}; }

    var firstAge = store.first && store.first.ts
      ? (Date.now() - Date.parse(store.first.ts)) / 86400000
      : Infinity;
    // Re-arm after 90 days. Crediting an enquiry to an ad clicked eight months
    // ago would be worse than crediting it to nothing.
    if (!store.first || !(firstAge < MAX_AGE_DAYS)) {
      store.first = touch;
      store.last = touch;
    } else if (identified) {
      store.last = touch;
    }

    localStorage.setItem(KEY, JSON.stringify(store));
  } catch (e) { /* never break the page over bookkeeping */ }
})();
